import { Typography } from '@mui/material'
import React from 'react'
import { useStyles } from './SearchResultsCount.styles'

type SearchResultsCountProps = {
  totalCount: number
  loading: boolean
  removePadding?: boolean
}

export const SearchResultsCount: React.FC<SearchResultsCountProps> = ({
  totalCount,
  loading,
  removePadding = false,
}) => {
  const { classes } = useStyles({ removePadding })
  return (
    <>
      {totalCount === 0 && !loading ? (
        <div
          className={classes.noResultHeaderContainer}
          data-testid="no-results"
        >
          <Typography className={classes.noResultHeading}>
            No results found.
          </Typography>
          <Typography className={classes.noResultSubHeading}>
            We couldn't find any results matching your search. Please try using
            different keywords or check your spelling.
          </Typography>
        </div>
      ) : (
        <>
          {totalCount > 0 && (
            <div
              className={classes.resultHeadingContainer}
              data-testid="showing-results-count"
            >
              <Typography className={classes.resultHeading}>
                Showing {totalCount} search result
                {totalCount !== 1 && 's'}.
              </Typography>
            </div>
          )}
        </>
      )}
    </>
  )
}
